import * as React from "react";
function SvgIcChevronLineLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.574 5l.65.375-3.85 6.668 3.85 6.669-.65.375-4.066-7.044L15.574 5zM7 5.188h.75V18.9H7V5.188z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronLineLeft;
